export default __webpack_public_path__ + "8d6d247375156c2c85c7f606018283b3.png";